import { create } from 'zustand';

const initialState = {
  tabValue: 0
}

const songListStore = create((set) => ({
  ...initialState,
  reset: () => { 
    set(initialState);
  },
  setTabValue: (event, val) => set((state) => ({ tabValue: val }))
}));

export default songListStore;